import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
export const PlatformStorageContext = createContext(undefined);
export const PlatformStorageProvider = ({ value, children, }) => _jsx(PlatformStorageContext.Provider, { value: value, children: children });
export function usePlatformStorage() {
    const ctx = useContext(PlatformStorageContext);
    if (!ctx) {
        throw new Error("usePlatformStorage must be used within a PlatformStorageProvider");
    }
    return ctx;
}
